import { render, staticRenderFns } from "./ProductsQuestion.vue?vue&type=template&id=bb36a3de&"
import script from "./ProductsQuestion.vue?vue&type=script&lang=js&"
export * from "./ProductsQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ProductsQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports